import React, { Component } from "react";
import Slider from "react-slick";
import { portfolioSlick2 } from "../../../page-demo/script";


const PortfolioList = [
    {
        image: 'image-1',
        category: ' Fotografia',
        title: 'Camaras y Accesorios'
    },
    {
        image: 'image-3',
        category: 'Accesorios',
        title: ' Impresoras y Suministros'
    },
    {
        image: 'image-4',
        category: 'Fotografia',
        title: ' Albunes y Marcos'
    },
    {
        image: 'image-2',
        category: 'Accesorios',
        title: ' Tecnologia y Accesorios'
    }
]

class Portfolio extends Component{
    render(){
        let title = 'Productos',
        description = 'Brindamos a nuestros clientes una alta variedad de productos fotográficos al mejor precio del mercado.';
        return(
            <React.Fragment>
                <div className="portfolio-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="section-title">
                                    <h2>{title}</h2>
                                    <p>{description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="portfolio-slick-activation mt--70 mt_sm--40">
                        <Slider {...portfolioSlick2}>
                            {PortfolioList.map((value , index) => (
                                <div className="portfolio" key={index}>
                                    <div className="thumbnail-inner">
                                        <div className={`thumbnail ${value.image}`}></div>
                                        <div className={`bg-blr-image ${value.image}`}></div>
                                    </div>
                                    <div className="content">
                                        <div className="inner">
                                            <p>{value.category}</p>
                                            <h4>{value.title}</h4>
                                            <div className="portfolio-button">
                                                <a className="rn-btn" href="/portfolio">Mas</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Portfolio;